/** Function to calculate the width of a column that should span multiple columns */
export function calcWidth(size: string, gap: string, span: number): string {
  if (span < 1) return size;
  return `calc(${size} * ${span} + ${gap} * ${span - 1})`;
}
